import React from "react";
import {motion} from 'framer-motion'
const Barbarian =()=> {
return (

    <div id="barbarian">
    <motion.h3  initial={{y:-50, opacity:0}}
          animate={{y:0, opacity:1}}
          transition={{duration:0.5}}className="flex gap-1 font-medium text-xl font-titleFont text-lightestslate"> Software Development Engineer <span className="text-green tracking-wide">@Barbarian</span></motion.h3>
    <motion.p  initial={{y:-50, opacity:0}}
          animate={{y:0, opacity:1}}
          transition={{duration:0.7}} className="mt-1 mb-1">
        June 2024 - Current
    </motion.p>

    <ul className="max-w-[70%]" >
    <motion.li  initial={{y:-50, opacity:0}}
          animate={{y:0, opacity:1}}
          transition={{duration:0.9}} className="flex gap-2 pt-2">
            <i className ="fa fa-arrow-right text-green pt-2"></i>
            <span>Built and scaled Node.js backend services handling 50k+ requests/min during Samsung flagship launches.</span>
        </motion.li>
        <motion.li  initial={{y:-50, opacity:0}}
          animate={{y:0, opacity:1}}
          transition={{duration:1.1}} className="flex gap-2 pt-2">
            <i className =" fa fa-arrow-right text-green pt-2"></i>
            <span className=''>Developed backend APIs powering reserve campaigns generating $10M+ in revenue.</span>
        </motion.li>

        <motion.li initial={{y:-50, opacity:0}}
          animate={{y:0, opacity:1}}
          transition={{duration:1.3}} className="flex gap-2 pt-2">
            <i className =" fa fa-arrow-right text-green pt-2"></i>
            <span className=''>Implemented Kafka-based event-driven pipelines supporting real-time data for 40k+ SKUs.</span>
        </motion.li>

        <motion.li initial={{y:-50, opacity:0}}
          animate={{y:0, opacity:1}}
          transition={{duration:1.3}} className="flex gap-2 pt-2">
            <i className =" fa fa-arrow-right text-green pt-2"></i>
            <span className=''>Designed Apache Airflow DAGs to process and transform customer PII data from Meta and Google campaigns.</span>
        </motion.li>

        <motion.li initial={{y:-50, opacity:0}}
          animate={{y:0, opacity:1}}
          transition={{duration:1.3}} className="flex gap-2 pt-2">
            <i className =" fa fa-arrow-right text-green pt-2"></i>
            <span className=''>Developed a live-commerce streaming platform (HLS) enabling interactive product experiences generating $1M+ revenue.</span>
        </motion.li>
       

        


        

    </ul>

</div>
)
}

export default Barbarian;